module.exports = __webpack_public_path__ + "static/img/img3d.24f0391.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/img3d.png
// module id = ZhIB
// module chunks = 1